import React, { Fragment } from 'react';

import DismissableMigrationDone from 'app/developer-v3/components/AppBuilder/CTA/CTAs/DismissableMigrationDone';
import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { MigrationStepName } from 'app/developer-v3/components/SidebarRight/types';
import { useVersionMigration } from 'app/developer-v3/hooks';

type Props = {
  integrationId: ID;
  persistId: string;
};

function Done(props: Props) {
  const { integrationId, persistId } = props;

  const { steps } = useVersionMigration(integrationId);
  const completedZapsCount = steps.find(
    ({ name }) => name === MigrationStepName.migrateZaps
  )?.finishedPoints;

  return (
    <DismissableMigrationDone
      completedZapsCount={completedZapsCount}
      helpLinks={
        <Fragment>
          Check out our{' '}
          <Link
            href={`${BASE_DOC_URL_VB}/manage/versions-ui#migrate-users-to-your-new-integration-version`}
            target="_blank"
          >
            version migration guide
          </Link>
          .
        </Fragment>
      }
      persistId={persistId}
    />
  );
}

export default Done;
